import React, { Fragment, useContext } from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  CardActionArea,
  Skeleton,
} from "@mui/material";
import { useQuery } from "react-query";
import { Link as RouterLink } from "react-router-dom";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import { grey } from "@mui/material/colors";
import { getStatsForDashboard } from "../../services/Dashboard";
import { WizardContext, ACTIONS } from "../wizard/Context";
import Check from "../../auth/ability";
import { CAN, SUBJECTS } from "../../auth/permissions";
import { useTheme } from '@mui/material/styles';
import { MODULES } from "../../services/Constants";
import useModule from "../../hooks/useModule";

const DashboardStats = () => {
  const { validateModuleWithMessage } = useModule();
  const { dispatch } = useContext(WizardContext);
  const theme = useTheme();
  const { data, isLoading } = useQuery(
    "getStatsForDashboard",
    getStatsForDashboard,
    {
      refetchOnWindowFocus: false,
    }
  );

  //const cardGradient = "linear-gradient(0deg, "+theme.palette.primary[600]+" 0%, #ffff 100%)"
  //const cardGradient = `linear-gradient(0deg, ${theme.palette.primary[600]} 0%, ${theme.palette.primary[200]} 2%, ${theme.palette.primary[50]} 15%, rgba(255,255,255,1) 100%);`
  //const cardGradient = `linear-gradient(135deg, #0FF0B3 0%,#036ED9 100%)`;
  const cardGradient = theme.custom.dashboardCardGradient;

  return (
    <Fragment>
      <Grid item xs={12} sm={6} md={2}>
        <CardActionArea LinkComponent={RouterLink} to={`/vehicles`}>
          <Card>
            <CardContent sx={{ background: cardGradient }}>
              {isLoading ? (
                <Skeleton animation="wave" />
              ) : (
                <Typography color="text.secondary">
                  Vehicles Provisioned
                </Typography>
              )}
              {isLoading ? (
                <Skeleton animation="wave" height={90} width={60} />
              ) : (
                <Typography
                  color="text.primary"
                  sx={{ fontSize: 60, fontWeight: 300 }}
                >
                  {data?.vehicles ? data.vehicles : "-"}
                </Typography>
              )}
            </CardContent>
          </Card>
        </CardActionArea>
      </Grid>
      <Grid item xs={12} sm={6} md={2}>
        <CardActionArea LinkComponent={RouterLink} to={`/images`}>
          <Card>
            <CardContent sx={{ background: cardGradient }}>
              {isLoading ? (
                <Skeleton animation="wave" />
              ) : (
                <Typography color="text.secondary">Images uploaded</Typography>
              )}
              {isLoading ? (
                <Skeleton animation="wave" height={90} width={60} />
              ) : (
                <Typography
                  color="text.primary"
                  sx={{ fontSize: 60, fontWeight: 300 }}
                >
                  {data?.images ? data.images : "-"}
                </Typography>
              )}
            </CardContent>
          </Card>
        </CardActionArea>
      </Grid>
      <Grid item xs={12} sm={6} md={2}>
        <CardActionArea LinkComponent={RouterLink} to={`/releases`}>
          <Card>
            <CardContent sx={{ background: cardGradient }}>
              {isLoading ? (
                <Skeleton animation="wave" />
              ) : (
                <Typography color="text.secondary">Releases</Typography>
              )}
              {isLoading ? (
                <Skeleton animation="wave" height={90} width={60} />
              ) : (
                <Typography
                  color="text.primary"
                  sx={{ fontSize: 60, fontWeight: 300 }}
                >
                  {data?.releases ? data.releases : "-"}
                </Typography>
              )}
            </CardContent>
          </Card>
        </CardActionArea>
      </Grid>
      <Grid item xs={12} sm={6} md={2}>
        <CardActionArea LinkComponent={RouterLink} to={`/deployments`}>
          <Card>
            <CardContent sx={{ background: cardGradient }}>
              {isLoading ? (
                <Skeleton animation="wave" />
              ) : (
                <Typography color="text.secondary">Deployments</Typography>
              )}
              {isLoading ? (
                <Skeleton animation="wave" height={90} width={60} />
              ) : (
                <Typography
                  color="text.primary"
                  sx={{ fontSize: 60, fontWeight: 300 }}
                >
                  {data?.deployments ? data.deployments : "-"}
                </Typography>
              )}
            </CardContent>
          </Card>
        </CardActionArea>
      </Grid>
      <Check I={CAN.CREATE} a={SUBJECTS.DEPLOYMENT}>
        <Grid item xs={12} sm={6} md={2}>
          <CardActionArea
            onClick={() => {
              if (validateModuleWithMessage(MODULES.OTA)) {
                dispatch({
                  type: ACTIONS.TOGGLE_WIZARD,
                  payload: {
                    showWizard: true,
                  },
                })
              }
            }
            }
          >
            <div className="dotted-card">
              <p className="dotted-text">CREATE A DEPLOYMENT</p>
              <div className="dotted-icon">
                <RocketLaunchIcon
                  sx={{ fontSize: "5.4rem", color: grey[500] }}
                />
              </div>
            </div>
          </CardActionArea>
        </Grid>
      </Check>
    </Fragment>
  );
};

DashboardStats.defaultProps = {};

DashboardStats.propTypes = {};

export default DashboardStats;
